import feature7401 from '@/assets/onboarding/7.4.0-1.png';
import feature7401Mobile from '@/assets/onboarding/7.4.0-1-mobile.png';
import feature7402 from '@/assets/onboarding/7.4.0-2.png';
import feature7402Mobile from '@/assets/onboarding/7.4.0-2-mobile.png';
import feature7403 from '@/assets/onboarding/7.4.0-3.png';
import feature7403Mobile from '@/assets/onboarding/7.4.0-3-mobile.png';
import feature7404 from '@/assets/onboarding/7.4.0-4.png';
import feature7404Mobile from '@/assets/onboarding/7.4.0-4-mobile.png';
import feature7405 from '@/assets/onboarding/7.4.0-5.png';
import feature7405Mobile from '@/assets/onboarding/7.4.0-5-mobile.png';
import feature9121 from '@/assets/onboarding/9.120.0-1.png';
import feature9121Mobile from '@/assets/onboarding/9.120.0-1-mobile.png';
import feature9122 from '@/assets/onboarding/9.120.0-2.png';
import feature9122Mobile from '@/assets/onboarding/9.120.0-2-mobile.png';
import feature9123 from '@/assets/onboarding/9.120.0-3.png';
import feature9123Mobile from '@/assets/onboarding/9.120.0-3-mobile.png';

/*
 * Available features that can be disabled in sites
 */
export const DAYPARTING_FEATURE = 'DAYPARTING_FEATURE';
export const SAVED_SEARCHES_FEATURE = 'SAVED_SEARCHES_FEATURE';
export const CONTENT_BAG_FEATURE = 'CONTENT_BAG_FEATURE';
export const IMAGE_FOCAL_POINT = 'IMAGE_FOCAL_POINT';
export const SHOW_ENTITY_IDS_IN_SELECTORS = 'SHOW_ENTITY_IDS_IN_SELECTORS';
export const CLIP_ORIGINAL_IMAGES_BEFORE_UPLOAD = 'RESIZE_ORIGINAL_IMAGES_ON_UPLOAD';
export const CREATE_AND_CONTINUE_WIZARD_BUTTON = 'CREATE_AND_CONTINUE_WIZARD_BUTTON';
export const USE_COMPOSITION_REALTIME_OVERLORD_CLIENT = 'USE_COMPOSITION_REALTIME_OVERLORD_CLIENT';
export const USE_PUBLIC_CLIPBOARD_AS_DEFAULT = 'USE_PUBLIC_CLIPBOARD_AS_DEFAULT';
export const SHOW_MODAL_CONFIRM_PUBLISH_WITHOUT_TAGS = 'SHOW_MODAL_CONFIRM_PUBLISH_WITHOUT_TAGS';
export const AUTOSAVE_ADVANCED_EDITOR = 'AUTOSAVE_ADVANCED_EDITOR';
export const CREATE_EMPTY_COMPOSITION_VERSION_FEATURE = 'CREATE_EMPTY_COMPOSITION_VERSION_FEATURE';
export const SHOW_MODAL_PUBLISH_NON_PUBLISHED_RELATED_CONTENTS = 'SHOW_MODAL_PUBLISH_NON_PUBLISHED_RELATED_CONTENTS';
export const SHOW_BUTTON_OPEN_SITE_IN_NEW_TAB = 'SHOW_BUTTON_OPEN_SITE_IN_NEW_TAB';
export const RELOAD_PAGE_WHEN_CHANGING_SITE = 'RELOAD_PAGE_WHEN_CHANGING_SITE';
export const USE_BY_WORDS_NORMALIZED_SELECT_FILTER = 'USE_BY_WORDS_NORMALIZED_SELECT_FILTER';
export const COPY_CONTENT_URL_WITHOUT_VERSION_ID = 'COPY_CONTENT_URL_WITHOUT_VERSION_ID';
export const DASHBOARD_FEATURE = 'DASHBOARD_FEATURE';
export const STAFF_NOTIFICATIONS = 'STAFF_NOTIFICATIONS';
export const TWO_FACTOR_AUTHENTICATION = 'TWO_FACTOR_AUTHENTICATION';
export const FEATURE_ID_DASHBOARD = 91201;

/**
 * @typedef OnboardingFeature
 * @property {Number} id
 * @property {String} patch
 * @property {*} image
 * @property {*} mobileImage
 * @property {String} title
 * @property {String} description
 * @property {String} [requiredFeature]
 * @property {Boolean} [deprecated]
 */

/** @type {OnboardingFeature[]} */
export const onboardingFeatures = [
  {
    id: 7401,
    patch: '7.4.0',
    image: feature7401,
    mobileImage: feature7401Mobile,
    title: 'Etiquetas navegables',
    description: 'Ahora puedes <strong>pulsar las etiquetas de un listado para realizar una acción relacionada</strong>. Por ejemplo, si pulsas sobre el tipo de contenido el listado cambiará para mostrarte sólo ese tipo de contenido o si pulsas sobre el ID éste se copiará en el portapapeles.',
    deprecated: true,
  },
  {
    id: 7402,
    patch: '7.4.0',
    image: feature7402,
    mobileImage: feature7402Mobile,
    title: 'Previsualización de contenidos',
    description: 'Hemos rediseñado los listados por completo para que sean más legibles e intuitivos. <strong>El nuevo botón “Previsualizar” muestra una vista previa de los contenidos</strong> para que puedas revisarlos rápidamente sin necesidad de abrir el editor.',
    deprecated: true,
  },
  {
    id: 7403,
    patch: '7.4.0',
    image: feature7403,
    mobileImage: feature7403Mobile,
    title: 'Portapapeles público',
    description: 'Herramientas de colaboración mejoradas con un <strong>portapapeles público</strong>. Cuando guardes tus módulos en el portapapeles ahora tienes la opción de hacerlos públicos, de esta forma el resto de miembros del equipo puede usarlos cuando los necesiten.',
    deprecated: true,
  },
  {
    id: 7404,
    patch: '7.4.0',
    image: feature7404,
    mobileImage: feature7404Mobile,
    title: 'Ventana de información',
    description: 'Hemos cambiado la <strong>ventana de información para que sea más legible y ofrezca más información</strong> relevante de un vistazo. También hemos añadido un botón para copiar la ID del contenido al portapapeles.',
    deprecated: true,
  },
  {
    id: 7405,
    patch: '7.4.0',
    image: feature7405,
    mobileImage: feature7405Mobile,
    title: '... y mucho más',
    description: 'Además de las nuevas características hemos realizado montones de pequeñas mejoras y ajustes para que la <strong>experiencia de uso, tanto en escritorio como en móvil, sea mucho más agradable y fácil</strong> de usar. Sumérgete y descubre todas las novedades de bCube.',
    deprecated: true,
  },
  {
    id: FEATURE_ID_DASHBOARD,
    patch: '9.120.0',
    image: feature9121,
    mobileImage: feature9121Mobile,
    title: 'Nuevo panel de control en bCube',
    description: 'Estrenamos un panel de control desde el que acceder a tus creaciones y publicaciones, a tus búsquedas guardadas, a tu actividad reciente y a aquellos accesos directos a acciones u objetos que usas más frecuentemente en tu día a día. Este panel es además tu nueva página de inicio al logarte en bCube.',
    requiredFeature: DASHBOARD_FEATURE,
  },
  {
    id: 91202,
    patch: '9.120.0',
    image: feature9122,
    mobileImage: feature9122Mobile,
    title: 'Personaliza tu panel de control',
    description: 'En varios tableros del panel puedes personalizar tu experiencia, añadiendo, quitando o reordenando los elementos que ves para que se adapten a tus necesidades. Clica en el icono "Opciones" (<i aria-hidden="true" class="material-icons v-icon" style="font-size: 18px;">more_vert</i>) en cada tablero y configúralo en función de las alternativas disponibles en cada caso. En algunos de ellos, como el de "Accesos directos", puedes añadir nuevos, eliminar los existentes o reordenarlos',
    requiredFeature: DASHBOARD_FEATURE,
  },
  {
    id: 91203,
    patch: '9.120.0',
    image: feature9123,
    mobileImage: feature9123Mobile,
    title: 'Selecciona tu página de inicio',
    description: 'Ahora puedes decidir qué página se muestra cada vez que inicias sesión en bCube. En el nuevo apartado "Personalizaciones" en tu perfil privado de staff, selecciona cuál será tu página de inicio: el nuevo panel de control es la opción elegida por defecto pero puedes modificarla si lo deseas.',
    requiredFeature: DASHBOARD_FEATURE,
  },
].filter(feature => !feature.deprecated);

/**
 * Api Configured features in the config service
 * This are the default values
 */
export default {
  // Habilita el editor avanzado/básico de contenidos
  [AUTOSAVE_ADVANCED_EDITOR]: false,
  // Funcionalidad de dayparting para editor de portadas
  [DAYPARTING_FEATURE]: true,
  // Busquedas guardadas. Añade la posibilidad de guardar busquedas y verlas en el content bag
  [SAVED_SEARCHES_FEATURE]: true,
  // Barra lateral para almacenar contenidos, módulos, busquedas y tags
  [CONTENT_BAG_FEATURE]: true,
  // Habilita la herramienta de seleccionar el punto focal de las imagenes
  [IMAGE_FOCAL_POINT]: false,
  // Muestra los ids de las entidades (no solo el tipo y el título) en los componentes de selección
  [SHOW_ENTITY_IDS_IN_SELECTORS]: true,
  // Habilita la herramienta de redimension al subir imagenes al cms
  [CLIP_ORIGINAL_IMAGES_BEFORE_UPLOAD]: true,
  // Obliga a los usuarios a redimensionar las imagenes al subirlas al cms
  FORCE_CLIP_ORIGINAL_IMAGES_BEFORE_UPLOAD: false,
  // Redimensiona las imagenes automáticamente antes de subirlas al cms
  AUTOMATIC_CLIP_ORIGINAL_IMAGES_BEFORE_UPLOAD: false,
  // Muestra el botón de crear y continuar en los wizards
  [CREATE_AND_CONTINUE_WIZARD_BUTTON]: true,
  // Utiliza como cliente de realtime para editar portadas overlord. Por defecto ya no se utiliza
  [USE_COMPOSITION_REALTIME_OVERLORD_CLIENT]: false,
  // Utiliza el clipboard público por defecto en vez del privado
  [USE_PUBLIC_CLIPBOARD_AS_DEFAULT]: false,
  // Habilita el modal de confirmación de publicación de contenido en caso éste no tenga tags
  [SHOW_MODAL_CONFIRM_PUBLISH_WITHOUT_TAGS]: false,
  // Habilita la opción de crear composiciones en blanco seleccionando el tipo
  [CREATE_EMPTY_COMPOSITION_VERSION_FEATURE]: false,
  // Habilita el modal de confirmación de publicación de contenidos relacionados no publicados
  [SHOW_MODAL_PUBLISH_NON_PUBLISHED_RELATED_CONTENTS]: false,
  // Habilita la opción de que aparezca un icono para abrir un Site en nueva pestaña en el selector de Sites.
  [SHOW_BUTTON_OPEN_SITE_IN_NEW_TAB]: true,
  [RELOAD_PAGE_WHEN_CHANGING_SITE]: false,
  // Permite que los selectores predictivos de entidades (contenidos, taxones, etc.) filtren los resultados
  // por palabras en lugar hacer una comparación estricta.
  [USE_BY_WORDS_NORMALIZED_SELECT_FILTER]: true,
  // Permite que al clickar en el chip de id que hay en la cabecera de los contenidos copie la url sin el
  // numero de la version, si esta a false copia el id del contenido
  [COPY_CONTENT_URL_WITHOUT_VERSION_ID]: false,
  // Muestra el flag de publicado o no en las busquedas de contenidos
  SHOW_PUBLISH_FLAG_SEARCH_CONTENT: false,
  // Deshabilita globalmente el recorte de imagenes ya existentes en el CMS
  DISABLE_IMAGE_CROP_IN_UPLOADED_IMAGES: false,
  // Habilita el dashboard.
  [DASHBOARD_FEATURE]: false,
  // Habilita las notificaciones a los staff
  [STAFF_NOTIFICATIONS]: false,
  // Indica si la verificación en dos pasos está activa.
  [TWO_FACTOR_AUTHENTICATION]: false,
};
